module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_10_3.7b2860fd.jpg";